import { ProjectExpensesComponent } from './project-expenses.component';
import { DatePickerModule } from '../date-picker/date-picker.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProjectExpensesService } from './project-expenses.service';
import { NgModule } from '@angular/core';
import { OpsNumberDirective } from '../directives/ops-number.directive';
import { DropdownModule } from '../dropdown/dropdown.module';
import { InvoiceModule } from './invoice/invoice.module';
import { ExpenseOverviewModule } from './expense-overview/expense-overview.module';
import { ExpenseAccordionModule } from './expense-accordion/expense-accordion.module';
import { EstimatesAndInvoicesModule } from './estimates-and-invoices/estimates-and-invoices.module';
import { InvoiceAddModule } from './invoice-add/invoice-add.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DatePickerModule,
    OpsNumberDirective,
    DropdownModule,
    InvoiceModule,
    ExpenseOverviewModule,
    ExpenseAccordionModule,
    EstimatesAndInvoicesModule,
    InvoiceAddModule,
    TranslateModule,
  ],
  exports: [ProjectExpensesComponent],
  declarations: [ProjectExpensesComponent],
  providers: [ProjectExpensesService],
})
export class ProjectExpensesModule {}
